import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
  PayrollRuleAPIService,
  PayrollRuleEntry,
} from 'app/api/payroll.rule.api.service';
import { AppState } from 'app/reducers';
import { parseErrorMessage } from 'app/utils/callstate';
import { sortBy } from 'lodash';
import { of, merge } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { PayrollRuleActions } from '../actions';

@Injectable()
export class PayrollRuleEffects {
  loadPayrollRule$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PayrollRuleActions.payrollRuleRequested),
      switchMap(({ query: { companyId, key, filter } }) =>
        this.payrollRuleApiService
          .PayrollRule(
            companyId,
            {
              beginsWith: 'pru',
            },
            filter
          )
          .pipe(
            map((entries) => PayrollRuleActions.payrollRuleLoaded({ entries })),
            catchError((error) =>
              of(
                PayrollRuleActions.payrollRuleCancelled({
                  errorMessage: parseErrorMessage(error),
                })
                // Load fake data
                // PayrollRuleActions.payrollRuleLoaded({ entries: INITIAL_EXTRA })
              )
            )
          )
      )
    )
  );

  createPayrollRule$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PayrollRuleActions.payrollRuleCreateRequested),
      mergeMap(({ input }) =>
        this.payrollRuleApiService.CreatePayrollRuleEntry(input).pipe(
          // tslint:disable-next-line: no-shadowed-variable
          map((input: PayrollRuleEntry) => {
            console.log('Rule created', input);
            return PayrollRuleActions.payrollRuleCreated({ input });
          }
          ),
          catchError((error) =>
            of(
              PayrollRuleActions.payrollRuleCancelled({
                errorMessage: parseErrorMessage(error),
              })
            )
          )
        )
      )
    )
  );

  deleteOnePayrollRule$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PayrollRuleActions.payrollRuleRemoveOneRequested),
      mergeMap(({ input }) =>
        this.payrollRuleApiService.DeletePayrollRuleEntry(input).pipe(
          map(
            // tslint:disable-next-line: no-shadowed-variable
            (i) => PayrollRuleActions.payrollRuleRemoved({ input: i }),
            catchError((error) =>
              of(
                PayrollRuleActions.payrollRuleRemoveFailed({
                  errorMessage: parseErrorMessage(error),
                })
              )
            )
          )
        )
      )
    )
  );

  updateOnePayrollRule$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PayrollRuleActions.payrollRuleUpdateOneRequested),
      mergeMap(({ input }) =>
        this.payrollRuleApiService.UpdatePayrollRuleEntry(input).pipe(
          // tslint:disable-next-line: no-shadowed-variable
          map((entry) =>
            PayrollRuleActions.payrollRuleUpdated({ input: entry })
          ),
          catchError((error) =>
            of(
              PayrollRuleActions.payrollRuleCancelled({
                errorMessage: parseErrorMessage(error),
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private payrollRuleApiService: PayrollRuleAPIService
  ) {}
}
